'use client';

import type { PageProps } from '@libs/core';
import type { Entry } from 'contentful';
import { buildPage } from '../../utils';

export default function ProductDetailsPage({ entry }: PageProps) {
    const { items } = entry?.fields || {};

    return buildPage(items as Entry[]);
}
